import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { bannerService } from '../services/api';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BannerCarousel = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await bannerService.getAll(true);
      setBanners(response.data);
    } catch (error) {
      console.error('Error al cargar banners:', error);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    adaptiveHeight: false,
  };

  if (loading) {
    return (
      <div className="w-full h-96 bg-gradient-to-r from-red-100 to-red-200 animate-pulse rounded-lg"></div>
    );
  }

  if (banners.length === 0) {
    return null;
  }

  return (
    <div className="w-full mb-8 banner-carousel">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <div key={banner.id} className="relative">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="relative h-96 md:h-[500px] overflow-hidden rounded-lg shadow-2xl"
            >
              <img
                src={banner.image_data}
                alt={banner.title || `Banner ${index + 1}`}
                className="w-full h-full object-cover"
              />
              {banner.title && (
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                  <h3 className="text-white text-2xl md:text-4xl font-bold">
                    {banner.title}
                  </h3>
                </div>
              )}
            </motion.div>
          </div>
        ))}
      </Slider>
      
      <style jsx>{`
        .banner-carousel .slick-prev:before,
        .banner-carousel .slick-next:before {
          color: #dc2626;
          font-size: 40px;
        }
        
        .banner-carousel .slick-dots li button:before {
          color: #dc2626;
          font-size: 12px;
        }
        
        .banner-carousel .slick-dots li.slick-active button:before {
          color: #dc2626;
        }
      `}</style>
    </div>
  );
};

export default BannerCarousel;
